import React, { useState, useEffect, useCallback } from "react";
import { Formik, Form } from "formik";
import { projectSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import RedioButton from "../../components/common/formInput/RedioButton";
import SearchSelectBox from "../../components/common/formInput/SearchSelectBox";
import { alert, confirm } from 'react-bootstrap-confirmation';
import { options, message, _status, Project_Type, project_status, publish_status, approach_type } from '../../components/common/utils/message';
import { useNavigate, useLocation } from "react-router-dom";
import { addProjects, project_details, updateProject, viewOneProject } from "../../services/project";
import { success, failed } from "../../components/common/Toastify";
import TextArea from "../../components/common/formInput/TextArea";
import _ from 'underscore';
import { useDispatch } from "react-redux";
import queryString from 'query-string';
import { Get_State } from "../../services/owner";
import { DragDropField } from "../../components/common/formInput/DragDropField";
import Icons from "../../assets/images";
import Modal from 'react-bootstrap/Modal'
import ApplicationMenuService from "../../services/application.menu";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import Editor from "../../components/common/formInput/Editor";
import { viewOneBuilding } from "../../services/building";
import ReactDatePicker from "../../components/common/formInput/DatePicker";
import ReactTimeRangePicker from "../../components/common/formInput/TimePicker";
import CreateProDesForm from "./CreateProDesForm";
import CreateDescriptionItems from "./CreateDescriptionItems";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DescriptionProjectForm from "./DescriptionProjectForm";
import moment from "moment";

const Option = (props) => {
    return (
        <div>
            <components.Option {...props}>

                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const CreateProjectForm = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [isStartDate, setIsStartDate] = useState(new Date())
    const [isEndDate, setIsEndDate] = useState(new Date());

    const [resPayload, setResPayload] = useState();
    const [resStates, setResStates] = useState();
    const [removedItems, setRemovedItems] = useState([]);
    const [openApplicationMenuForm, setOpenApplicationMenuForm] = useState(false);
    const [applicationMenu, setApplcationMenu] = useState([]);
    const [allowedBids, setAllowedbids] = useState([]);
    const [selectedManufactures, setSelectedManufactures] = useState([]);
    const [projectDetails, setProjectDetails] = useState();
    const [buildings, setBuildings] = useState();
    const [buildingDetails, setBuildingDetails] = useState();

    const [selectedMenus, setSelectedMenus] = useState([]);

    const [projDescription, setProjDescription] = useState([
        {
            _id: "",
            title: "",
            description: "",
            is_master: ""
        }
    ]);

    const project_id = queryString.parse(location.search);

    const selectAllowedBidsStates = (selected) => {
        setAllowedbids(selected)
    }
    const selectManfacturer = (selected) => {
        setSelectedManufactures(selected)
    }
console.log(' project_id.id project_id.id--- 89 --- ', project_id.id )
    useEffect(() => {
        viewOneProject(project_id, (data) => {
            setResPayload(data);
            if (project_id.id) {
                setSelectedMenus(data.selectedMenuItems);
                setAllowedbids(data.allowedBid);
                setSelectedManufactures(data.manufacturers);
            }
        }, dispatch);
        Get_State({ country: "United States" }, result => { setResStates(result.data); }, dispatch);
        getApplicationMenus();
    }, []);

    const projDesp = useCallback((res) => {
        setProjDescription(res)
    }, [])

    const chooseMessageProjDesp = (projDescription) => {
        setProjDescription(projDescription);
    };

   console.log(' setProjDescription 111 data come from DespProjForm component -- ', projDescription);
    const initialData = {
        project_title: resPayload ? resPayload.project_title : "",
        approach_type: resPayload ? resPayload.approach_type : "",
        ownerId: resPayload ? resPayload.ownerId?._id : "",
        buildingId: resPayload ? resPayload.buildingId?._id : "",
        square_footage: resPayload ? resPayload.square_footage : "",
        manufacturers: resPayload ? resPayload.manufacturers : "",
        // bidder_fee: resPayload ? resPayload.bidder_fee : "",
        allowedBid: resPayload ? resPayload.allowedBid : "",
        project_status: resPayload ? resPayload.project_status : "",
        publish_status: resPayload ? resPayload.publish_status : "",
        notes: resPayload ? resPayload.notes : "",
        description: resPayload ? resPayload.description : "",
        images: resPayload ? resPayload.images : "",
        roof_drawings: resPayload ? resPayload.roof_drawings : "",
        standard_contract: resPayload ? resPayload.standard_contract : "",
        insurance: resPayload ? resPayload.insurance : "",
        detail_drawings: resPayload ? resPayload.detail_drawings : "",
        specifications: resPayload ? resPayload.specifications : "",
        videos: resPayload ? resPayload.videos : "",
        status: resPayload ? resPayload.status : "",
        removed_items: removedItems ? removedItems : [],
        country: buildingDetails === undefined ? resPayload?.country : buildingDetails?.country,
        state: buildingDetails === undefined ? resPayload?.state : buildingDetails?.state,
        city: buildingDetails === undefined ? resPayload?.city : buildingDetails?.city,
        bid_start_date: resPayload ? resPayload.bid_start_date : "",
        bid_end_date: resPayload ? resPayload.bid_end_date : "",
        bidder_fee: resPayload ? resPayload.bidder_fee : "",
        winners_bidder_fee: resPayload ? resPayload.winners_bidder_fee : "",


    }

    useEffect(() => {
        project_details((data) => {
            setProjectDetails(data);
        })
    }, [])

    const [initialValue, setInitialValue] = useState(initialData);

    // For selected owner's Building data.....
    useEffect(() => {
        if (resPayload?.ownerId?._id)
            evaluateBuilding(resPayload?.ownerId?._id);
    }, [projectDetails])

    useEffect(() => {
        setInitialValue(initialData)
    }, [resPayload, buildings])

    let ownerListData = projectDetails?.owner?.map((item) => ({ value: item._id, label: `${item.first_name} - ${item.company_name}` }));
    let manufacturerData = projectDetails?.manufacturer?.map((item) => ({ value: item._id, label: item.first_name }));
    let statesData = resStates && resStates.states && resStates.states.map((item) => ({ value: item.name, label: item.name }));

    /**
     * @description function is for evaluate owner's id and there building data.
     * @param {id} id 
     */
    const evaluateBuilding = async (id) => {
        let findOwner = await _.findWhere(projectDetails?.owner, { _id: id })
        let build = []
        for (var i = 0; i < findOwner.buildings.length; i++) {
            build.push({ value: findOwner.buildings[i]._id, label: findOwner.buildings[i].name })
        }
        setBuildings(build)
    }

    const evaluateBuildingstate = async (id) => {
        await viewOneBuilding(id, (data) => { setBuildingDetails(data) }, dispatch)

    }




    /**
     * @description Function is used for add Project 
     * @param {object} data 
     */
    const _submitData = (data) => {
        let form = new FormData();
        form.append("ownerId", data.ownerId)
        form.append("project_title", data.project_title)
        form.append("approach_type", data.approach_type)
        form.append("building_type", buildingDetails.building_type)
        form.append("buildingId", data.buildingId)
        form.append("square_footage", data.square_footage)
        form.append("manufacturers", JSON.stringify(selectedManufactures))
        //form.append("bidder_fee", data.bidder_fee)
        form.append("allowedBid", JSON.stringify(allowedBids))
        form.append("project_status", data.project_status)
        form.append("publish_status", data.publish_status)
        form.append("notes", data.notes)
        form.append("description", data.description)
       // form.append("projectDescription", JSON.stringify(projDescription))
        form.append("status", data.status)
        form.append("selectedMenuItems", JSON.stringify(selectedMenus))
        form.append("country", buildingDetails.country)
        form.append("state", buildingDetails.state)
        form.append("city", buildingDetails.city);
        form.append("zip_code", buildingDetails.zip_code);
        form.append("address", buildingDetails.address1);
        form.append("address1", buildingDetails.address1);
        form.append("address2", buildingDetails.address2);
        form.append("bidder_fee", data.bidder_fee);
        form.append("winners_bidder_fee", data.winners_bidder_fee);
        form.append("bid_start_date", data.bid_start_date);
        form.append("bid_end_date", data.bid_end_date);
        if (data.images) {
            for (let i = 0; i < data.images.length; i++) {
                form.append("images", data.images[i]);
            }
        }
        if (data.roof_drawings) {
            for (let i = 0; i < data.roof_drawings.length; i++) {
                form.append("roof_drawings", data.roof_drawings[i]);
            }
        }
        if (data.videos) {
            for (let i = 0; i < data.videos.length; i++) {
                form.append("videos", data.videos[i]);
            }
        }
        if (data.standard_contract) {
            for (let i = 0; i < data.standard_contract.length; i++) {
                form.append("standard_contract", data.standard_contract[i])
            }
        }
        if (data.insurance) {
            for (let i = 0; i < data.insurance.length; i++) {
                form.append("insurance", data.insurance[i])
            }
        }
        if (data.detail_drawings) {
            for (let i = 0; i < data.detail_drawings.length; i++) {
                form.append("detail_drawings", data.detail_drawings[i])
            }
        }
        if (data.specifications) {
            for (let i = 0; i < data.specifications.length; i++) {
                form.append("specifications", data.specifications[i])
            }
        }


        try {
            addProjects(form, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    console.log(' addProjects Resulet--- ', result.data._id)
                   
                    success(result.message);
                    debugger;
                    // navigate('/project-list')
                    navigate(`/project-form?id=${result.data._id}`)
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };


    /**
    * @description Function is for Update prject.
    * @param {object} data 
    */
    const _updateData = async (data) => {
        let form = new FormData();
        form.append("_id", resPayload._id)
        form.append("project_title", data.project_title)
        form.append("approach_type", data.approach_type)
        form.append("ownerId", data.ownerId)
        form.append("building_type", buildingDetails != undefined ? buildingDetails.building_type : resPayload?.buildingId?.building_type)
        form.append("buildingId", data.buildingId)
        form.append("square_footage", data.square_footage)
        form.append("status", data.status)
        //  form.append("project_status", data.project_status)
        form.append("publish_status", data.publish_status)
        if (data.manufacturers) form.append("manufacturers", JSON.stringify(selectedManufactures))
        if (data.bidder_fee) form.append("bidder_fee", data.bidder_fee)
        if (data.winners_bidder_fee) form.append("winners_bidder_fee", data.winners_bidder_fee)
        if (data.allowedBid) form.append("allowedBid", JSON.stringify(allowedBids))
        if (data.project_status) form.append("project_status", data.project_status)
        if (data.notes) form.append("notes", data.notes)
        if (data.description) form.append("description", data.description)
        if (data.removed_items) form.append("removed_items", JSON.stringify(data.removed_items))
        form.append("selectedMenuItems", JSON.stringify(selectedMenus))
        form.append("projectDescription", JSON.stringify(projDescription))
        form.append("country", buildingDetails === undefined ? data.country : buildingDetails?.country)
        form.append("state", buildingDetails === undefined ? data.state : buildingDetails?.state)
        form.append("city", buildingDetails === undefined ? data.city : buildingDetails?.city)
        // form.append("bidder_fee", data.bidder_fee);
        form.append("bid_start_date", data.bid_start_date);
        form.append("bid_end_date", data.bid_end_date);
        if (data.images) {
            for (let i = 0; i < data.images.length; i++) {
                form.append("images", data.images[i]);
            }
        }
        if (data.roof_drawings) {
            for (let i = 0; i < data.roof_drawings.length; i++) {
                form.append("roof_drawings", data.roof_drawings[i]);
            }
        }
        if (data.videos) {
            for (let i = 0; i < data.videos.length; i++) {
                form.append("videos", data.videos[i]);
            }
        }
        if (data.standard_contract) {
            for (let i = 0; i < data.standard_contract.length; i++) {
                form.append("standard_contract", data.standard_contract[i])
            }
        }
        if (data.insurance) {
            for (let i = 0; i < data.insurance.length; i++) {
                form.append("insurance", data.insurance[i])
            }
        }
        if (data.detail_drawings) {
            for (let i = 0; i < data.detail_drawings.length; i++) {
                form.append("detail_drawings", data.detail_drawings[i])
            }
        }
        if (data.specifications) {
            for (let i = 0; i < data.specifications.length; i++) {
                form.append("specifications", data.specifications[i])
            }
        }
        try {
            updateProject(form, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    // navigate("/project-form?id=63ef62ad1b6be50ed6793fae")
                    navigate(`/project-form?id=${resPayload._id}`)


                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelProjectForm, options);
        if (result) {
            // alert(message.canceled);
            navigate('/project-list')
        }
    }


    /**
     * @description Function is For Delete/update Media.
     */
    const updatemedia = async (id) => {
        const result = await confirm(message.deleteData, options);
        if (result) {
            let inx = resPayload?.media.findIndex((item) => item._id === id)
            let obj = resPayload?.media?.splice(inx, 1)
            setRemovedItems([...removedItems, obj[0]])
            setResPayload({ ...resPayload, media: resPayload.media })
        }
    }

    const openApplicationMenu = () => {
        const updatedApplicationMenu = [...applicationMenu];
        const selectedIds = selectedMenus.map(e => e._id);
        updatedApplicationMenu.forEach(m => {
            if (selectedIds.includes(m._id)) {
                m.checked = true;
            } else {
                m.checked = false
            }

        })

        setOpenApplicationMenuForm(true)
    };

    const closeApplicationMenu = () => {
        const updatedApplicationMenu = [...applicationMenu];
        updatedApplicationMenu.forEach(m => {
            m.checked = false
        })
        setApplcationMenu(updatedApplicationMenu);
        setOpenApplicationMenuForm(false);
    }

    const getApplicationMenus = () => {
        ApplicationMenuService.getAllApplicationMenu((result) => {
            const withCheckMenus = result?.map(e => {
                if (e.type === "dropdown" || e.type === "multi-dropdown") {

                    const updatedOptions = e.options.map(opt => {
                        return {
                            label: opt.key,
                            value: opt.value
                        }
                    })
                    e.options = [...updatedOptions];
                    e.selectedOptions = [];
                }
                if (e.type === "boolean") {
                    e.options = [...e.options]
                }
                if (e.type === "text") {
                    e.selectedOptions = [""];
                }
                if (e.type === "range") {
                    e.selectedOptions = [0];
                }
                return { ...e, menuId: e._id, checked: false };
            });

            setApplcationMenu(withCheckMenus);
        }, dispatch)
    }

    const selectMenu = (e) => {

        const updatedApplicationMenu = [...applicationMenu];

        updatedApplicationMenu.forEach(m => {
            if (m.menu_title === e.target.value) {
                if (m.checked) { m.checked = false; }
                else { m.checked = true }
            }
        })
        setApplcationMenu(updatedApplicationMenu);
    }

    const _submitApplicationMenuForm = () => {
        const updatedSelectedMenu = applicationMenu.filter(e => e.checked);
        const existedMenu = selectedMenus.map(e => e._id);
        setSelectedMenus([...selectedMenus, ...updatedSelectedMenu.filter(e => !existedMenu.includes(e._id))]);
        closeApplicationMenu();
    };

    const deleteApplicationMenu = (menuId) => {
        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        udpatedSelectedMenus.splice(menuIndex, 1)
        setSelectedMenus(udpatedSelectedMenus);
    }

    const textTypeHandler = (e, menuId) => {

        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        udpatedSelectedMenus[menuIndex].selectedOptions[0] = e.target.value;
        setSelectedMenus(udpatedSelectedMenus);

    }

    const rangeTypeHandler = (e, menuId) => {

        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        udpatedSelectedMenus[menuIndex].selectedOptions[0] = +e.target.value;
        setSelectedMenus(udpatedSelectedMenus);
    }
    const dropdownTypeHandler = (e, menuId) => {

        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        udpatedSelectedMenus[menuIndex].selectedOptions[0] = e.target.value;
        setSelectedMenus(udpatedSelectedMenus);
    }
    const multidropdownTypeHandler = (e, menuId) => {

        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        const optionsIndex = udpatedSelectedMenus[menuIndex].selectedOptions.findIndex(x => x === e.target.value);
        if (optionsIndex < 0) {
            udpatedSelectedMenus[menuIndex].selectedOptions.push(e.target.value)
        } else {
            udpatedSelectedMenus[menuIndex].selectedOptions.splice(optionsIndex, 1);
        }
        setSelectedMenus(udpatedSelectedMenus);
    }
    const booleanTypeHandler = (e, menuId) => {

        const udpatedSelectedMenus = [...selectedMenus];
        const menuIndex = udpatedSelectedMenus.findIndex(e => e._id === menuId);
        const optionsIndex = udpatedSelectedMenus[menuIndex].selectedOptions.findIndex(x => x === e.target.value);
        if (e.target.value === "on") {
            udpatedSelectedMenus[menuIndex].options[optionsIndex].selected = true

        } else {
            udpatedSelectedMenus[menuIndex].options[optionsIndex].selected = false
        }
        setSelectedMenus(udpatedSelectedMenus);
    }
    


    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialValue}
                enableReinitialize
                validationSchema={projectSchema}
                onSubmit={(values) => resPayload ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form >
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">{resPayload ? "Edit Project" : "Create New Project"}</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Project Name"
                                                name="project_title"
                                                value={formik?.values?.project_title}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Approach Type"
                                                name="approach_type"
                                                options={approach_type}
                                                value={formik?.values?.approach_type}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Project Status "
                                                name="project_status"

                                                options={project_status}
                                                value={formik?.values?.project_status}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Select Owner"
                                                name="ownerId"
                                                value={formik?.values?.ownerId}
                                                changeHandle={(val) => {
                                                    evaluateBuilding(val);
                                                }}
                                                required={true}
                                                options={ownerListData}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Select Building"
                                                name="buildingId"
                                                value={formik?.values?.buildingId}
                                                changeHandle={(val) => {
                                                    evaluateBuildingstate({ id: val });
                                                }}
                                                required={true}
                                                options={buildings}
                                            />
                                        </div>
                                    </div>
                                    {(buildingDetails != undefined) ?
                                        <div className="f-row alignTop">
                                            <div className="f-33">
                                                <TextField
                                                    label="Building Address"
                                                    name="builiding_address"
                                                    value={buildingDetails.address1}
                                                    disabled={true}

                                                />
                                            </div>
                                            <div className="f-33">
                                                <TextField
                                                    label="Builiding City"
                                                    name="city"
                                                    value={buildingDetails.city}
                                                    disabled

                                                />
                                            </div>
                                            <div className="f-33">
                                                <TextField
                                                    label="Builiding State"
                                                    name="state"
                                                    value={buildingDetails.state}
                                                    disabled

                                                />
                                            </div>
                                        </div> : " "}
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <SearchSelectBox
                                                label="Publish Status"
                                                name="status"
                                                required={true}
                                                options={_status}
                                                value={formik?.values?.status}
                                                onChange={formik.handleChange}

                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Size in SF"
                                                name="square_footage"
                                                value={formik?.values?.square_footage}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <label className="f-label">Manufacturers</label>
                                            <div className='f-field'>
                                                <div className='cm-dropdown multi-check-drop'>
                                                    <ReactSelect
                                                        className="pro-input-two pro-select-two-new"
                                                        options={manufacturerData}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        components={{
                                                            Option
                                                        }}
                                                        onChange={selectManfacturer}
                                                        allowSelectAll={true}
                                                        value={selectedManufactures}
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add Application Menu</h5>
                                <button className="btn btn-grey m-r-15" type="button" onClick={openApplicationMenu}> Select Menus</button>
                            </div>
                            <div className="f-row alignTop">
                                {Array.isArray(selectedMenus) &&
                                    selectedMenus.map(_menu => {

                                        return (<>
                                            {_menu.type === "text" &&
                                                <div className="f-33 d-flex align-items-start mb-3">
                                                    <div className='high-low-value'>
                                                        <p>{_menu.menu_title}</p>
                                                        <div className="h-l-dropdown">
                                                            <input type="text" value={_menu.selectedOptions[0]} name={_menu.key} onInput={(e) => textTypeHandler(e, _menu.menuId)} />
                                                        </div>
                                                    </div>
                                                    <img src={Icons.removeIcon} className='icons-size icons-input-margin' onClick={() => deleteApplicationMenu(_menu.menuId)} />
                                                </div>
                                            }
                                            {_menu.type === "range" &&
                                                <div className="f-33 d-flex align-items-start mb-3">
                                                    <div className='high-low-value'>
                                                        <p>{_menu.menu_title}</p>
                                                        <div className="h-l-dropdown">
                                                            <div>
                                                                <input type="number" value={_menu.selectedOptions[0]} name={_menu.key} min={_menu.min_value} max={_menu.max_value} onInput={(e) => rangeTypeHandler(e, _menu.menuId)} />
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <img src={Icons.removeIcon} className='icons-size icons-input-margin' onClick={() => deleteApplicationMenu(_menu.menuId)} />
                                                </div>
                                            }
                                            {
                                                _menu.type === "boolean" &&
                                                <div className="f-33 d-flex align-items-start mb-3">
                                                    <div className='high-low-value'>
                                                        <p>{_menu.menu_title}</p>
                                                        <div className="h-l-dropdown">
                                                            {_menu.options.map(opt => {
                                                                return (
                                                                    <div>
                                                                        <input type="radio" name={_menu.key} checked={opt.selected} onChange={(e) => booleanTypeHandler(e, _menu.menuId, opt.value)} /> {
                                                                            opt.value
                                                                        }
                                                                    </div>
                                                                )
                                                            })}

                                                        </div>
                                                    </div>
                                                    <img src={Icons.removeIcon} className='icons-size icons-input-margin' onClick={() => deleteApplicationMenu(_menu.menuId)} />
                                                </div>

                                            }
                                            {
                                                _menu.type === "dropdown" &&
                                                <div className="f-33 d-flex align-items-start mb-3">
                                                    <ul className="dashboard-sub-filters sub-filters-select">
                                                        <li>
                                                            {_menu.options && <div className='sortby multiple-select-sortby'>
                                                                <span className="roof-text">{_menu.menu_title} :</span>
                                                                <div className='nocolor-dropdown'>
                                                                    <select name={_menu.key} value={_menu.selectedOptions[0]} onChange={(e) => dropdownTypeHandler(e, _menu.menuId)} >
                                                                        {_menu.options.map(opt => {
                                                                            return <option value={opt.value} >{opt.label}</option>
                                                                        })}
                                                                    </select>
                                                                </div>
                                                            </div>}
                                                        </li>
                                                    </ul>
                                                    <img src={Icons.removeIcon} className='icons-size icons-input-margin' onClick={() => deleteApplicationMenu(_menu.menuId)} />
                                                </div>
                                            }
                                            {
                                                _menu.type === "multi-dropdown" &&
                                                <div className="f-33 d-flex align-items-start mb-3">
                                                    <ul className="dashboard-sub-filters sub-filters-select">
                                                        <li>
                                                            {_menu.options && <div className='sortby multiple-select-sortby'>
                                                                <span className="roof-text">{_menu.menu_title} :</span>
                                                                <div className='nocolor-dropdown'>
                                                                    <select name={_menu.key} value={_menu.selectedOptions} onChange={(e) => multidropdownTypeHandler(e, _menu.menuId)} multiple>
                                                                        {_menu.options.map(opt => {
                                                                            return <option value={opt.value} >{opt.label}</option>
                                                                        })}
                                                                    </select>

                                                                </div>
                                                            </div>}
                                                        </li>
                                                    </ul>
                                                    <img src={Icons.removeIcon} className='icons-size icons-input-margin' onClick={() => deleteApplicationMenu(_menu.menuId)} />
                                                </div>
                                            }
                                        </>

                                        )
                                    })}
                            </div>
                        </div>

                        <div className="d-card m-b-25">
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <DragDropField
                                                label=" Upload standard Contract Pdf"
                                                name="standard_contract"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "standard_contract") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file008"
                                                accept={'application/pdf'}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Insurance Pdf"
                                                name="insurance"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "insurance") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file009"
                                                accept={'application/pdf'}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">
                                    Upload Project Specific Items
                                </h5>
                            </div>
                            <div className="d-card-body">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Roof Drawing Pdf"
                                                name="roof_drawings"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "roof_drawings") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file0010"
                                                accept={'application/pdf'}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Roof Photos"
                                                name="images"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "images") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file0011"
                                                accept={'image/jpeg'}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Project Video"
                                                name="videos"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "videos") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file0013"
                                                accept={'video/mp4'}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Detail Drawings Pdf"
                                                name="detail_drawings"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "detail_drawings") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file0012"
                                                accept={['application/pdf']}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <DragDropField
                                                label="Upload Project Specifications Pdf"
                                                name="specifications"
                                                media={resPayload?.media?.filter((item) => { if (item.type === "specifications") return item }) || []}
                                                updatemedia={updatemedia}
                                                isrequired={true}
                                                id="file0018"
                                                accept={['application/pdf']}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-100">
                                            <TextArea
                                                label="Any Specific Notes Regarding The Project"
                                                name="notes"
                                                value={formik?.values?.notes}
                                                onChange={formik.handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row">
                                        {/* <div className="f-33">
                                            <label className="f-label">Bid is allowed from</label>
                                            <div className='f-field'>
                                                <div className='cm-dropdown multi-check-drop'>
                                                    <ReactSelect
                                                        className="pro-input-two pro-select-two-new"
                                                        options={statesData}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        components={{
                                                            Option
                                                        }}
                                                        onChange={selectAllowedBidsStates}
                                                        allowSelectAll={true}
                                                        value={allowedBids}
                                                    />
                                                </div>
                                            </div>
                                        </div> */}
                                        {/*<div className="f-33">
                                            <label className="f-label">Project Status</label>
                                            <div className="f-field">
                                                <div className="checkbox-row">
                                                    <RedioButton
                                                        label="Open Project"
                                                        name="project_status"
                                                        checked={formik?.values?.project_status === 'open'}
                                                        value="open"
                                                        onChange={formik.handleChange} />
                                                    <RedioButton
                                                        label="Close Project"
                                                        name="project_status"
                                                        checked={formik?.values?.project_status === 'close'}
                                                        value="close"
                                                        onChange={formik.handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                    */}
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">
                                    Bid Settings
                                </h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Bid Amount Fees"
                                                name="bidder_fee"
                                                value={formik?.values?.bidder_fee}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>

                                        <div className="f-33">
                                            <ReactDatePicker
                                                label={"Bid Starts"}
                                                name="bid_start_date"
                                                placeholder="Select Bid Starts Date"
                                                selected={isStartDate}
                                                dateFormat="yyyy/MM/dd"
                                                // value= {moment(formik?.values?.bid_start_date).format('yyyy/MM/DD')}
                                                value={formik?.values?.bid_start_date}
                                                isrequired={true}
                                                //onChange={formik.handleChange}
                                                //onChange={date => setFieldValue('bid_start_date', date)}
                                                changeHandle={(date) => setIsStartDate(date)}
                                            /> 
                                            {/* <DatePicker
                                                label={"Bid Starts"}
                                                name="bid_start_date"
                                                placeholder="Select Bid Starts Date"
                                                dateFormat="yyyy/MM/dd"
                                                value={formik?.values?.bid_start_date}
                                                isrequired={true}
                                                selected={isStartDate}
                                                onChange={(date) => setIsStartDate(date)}
                                            /> */}
                                            {/* <ReactTimeRangePicker
                                                label={"Bid Starts"}
                                                name="bid_start_time"
                                                placeholder="Select Bid Starts Time"
                                                selected={isStartDate}
                                                dateFormat="h:m:s"
                                                value={formik?.values?.bid_start_date}
                                                required={true}
                                                //onChange={formik.handleChange}
                                                //onChange={date => setFieldValue('bid_start_date', date)}
                                                changeHandle={(date) => setIsStartDate(date)}
                                            />  */}



                                        </div>
                                        <div className="f-33">
                                            <ReactDatePicker
                                                label={"Bid Ends"}
                                                name="bid_end_date"
                                                placeholder="Select Bid Ends Time"
                                                selected={ isStartDate <  isEndDate ? isEndDate : isStartDate}
                                                dateFormat="yyyy/MM/dd"
                                                // value={moment(formik?.values?.bid_end_date).format('yyyy/MM/DD')}
                                                value={formik?.values?.bid_end_date}
                                                isrequired={true}
                                                //changeHandle={(date) => formik.setFieldValue(date)}
                                                changeHandle={(date) => setIsEndDate(date)}
                                            />

                                            {/* <DatePicker
                                                label={"Bid Ends"}
                                                name="bid_end_date"
                                                placeholder="Select Bid Ends Time"
                                                dateFormat="yyyy/MM/dd"
                                                value={formik?.values?.bid_end_date}
                                                isrequired={true}
                                                selected={isEndDate}
                                                onChange={(date) => setIsEndDate(date)}
                                            /> */}
                                        </div>
                                    </div>

                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <label className="f-label">Bid is allowed from</label>
                                            <div className='f-field'>
                                                <div className='cm-dropdown multi-check-drop'>
                                                    <ReactSelect
                                                        className="pro-input-two pro-select-two-new"
                                                        options={statesData}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        components={{
                                                            Option
                                                        }}
                                                        onChange={selectAllowedBidsStates}
                                                        allowSelectAll={true}
                                                        value={allowedBids}
                                                        required={true}
                                                    />

                                                </div>

                                            </div>

                                            <div className="f-33">
                                                <TextField
                                                    label="Wining bid Fees"
                                                    name="winners_bidder_fee"
                                                    value={formik?.values?.winners_bidder_fee}
                                                    onChange={formik.handleChange}
                                                    required={true}
                                                />
                                            </div>

                                            {/* <SearchSelectBox
                                                label="Status"
                                                name="status"
                                                options={_status}
                                                value={formik?.values?.status}
                                                onChange={formik.handleChange}
                                            /> */}
                                        </div>
                                        {/* <div className="f-33">
                                            <TextField
                                                label="Square Footage"
                                                name="square_footage"
                                                value={formik?.values?.square_footage}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div> */}
                                        {/* <div className="f-33">
                                            <label className="f-label">Manufacturers</label>
                                            <div className='f-field'>
                                                <div className='cm-dropdown multi-check-drop'>
                                                    <ReactSelect
                                                        className="pro-input-two pro-select-two-new"
                                                        options={manufacturerData}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        hideSelectedOptions={false}
                                                        components={{
                                                            Option
                                                        }}
                                                        onChange={selectManfacturer}
                                                        allowSelectAll={true}
                                                        value={selectedManufactures}
                                                    />
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* project description */}
                        <div className="d-card m-b-25 pro-des">
                            {/* < CreateProDesForm chooseMessageProjDesp={chooseMessageProjDesp} /> */}

                            {/* <CreateDescriptionItems/>    */}
                            {project_id.id != null || project_id.id != undefined ?
                            <DescriptionProjectForm chooseMessageProjDesp={chooseMessageProjDesp} />
                            : ''}
                        </div>
                        {project_id.id == null || project_id.id == undefined ? 
                        <div className="d-card-bottom">
                            
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{resPayload ? "Edit Project" : "Add Project"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" type="button" onClick={onCancel}>Cancel</button>
                            </div> 
                            {/* <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="button" onClick={(values) => resPayload ? _updateData(values) : _submitData(values)}>Submit</button>
                            </div> */}
                            
                        </div> : "" }
                    </Form>
                )}
            </Formik>
            {/* onSubmit={(values) => resPayload ? _updateData(values) : _submitData(values)} */}
            {openApplicationMenuForm &&
                <Modal
                    show={openApplicationMenuForm}
                    onHide={closeApplicationMenu}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>
                        <div className="contractor-wrapper">
                            <h5 className="contractor-heading">Select Application Menu</h5>
                            <div className="contractor-body">
                                <ul className="contractor-list">
                                    {applicationMenu && applicationMenu.map((_menu, index) => {
                                        return (<li>
                                            <div className="contractor-check">
                                                {/* <label className='checkbox nolabel' htmlFor={index}> */}
                                                <label className='checkbox nolabel' >
                                                    <input type="checkbox" id={index} value={_menu.menu_title} checked={_menu.checked} onChange={(e) => selectMenu(e)} />
                                                    <span></span>
                                                </label>
                                            </div>
                                            <div className="contractor-details">
                                                <div className='bid-details'>
                                                    <h4>{`${_menu.menu_title}`}</h4>
                                                </div>
                                            </div>
                                        </li>)
                                    })}
                                </ul>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <ul className="modal-actions">
                            <li>
                                <button className="btn btn-primary" type="submit" onClick={_submitApplicationMenuForm}>Submit</button>
                            </li>
                            <li>
                                <button className="btn btn-grey" type="button" onClick={closeApplicationMenu}>Cancel</button>
                            </li>
                        </ul>
                    </Modal.Footer>
                </Modal>}
        </div >
    );
};

export default CreateProjectForm;
